export async function requestSetBanner(image: string) {
  return http.post('/v1/user/set_banner_image', { image })
}
